<template>
  <div id="CropUpload">
    <Uploader
      v-bind="Object.assign(itemArr, { multiple: false, beforeRead: beforeLoad, afterRead: onsuccess })"
      accept="image/*"
      @oversize="$emit('oversize')"
    >
      <slot>
        <div class="upload-content" :class="transCls">
          <img src="./bj.png" alt="" />
          <p style="margin-bottom: 0;">点击上传</p>
        </div>
      </slot>
    </Uploader>
  </div>
</template>

<script>
import { Uploader, Toast } from "vant"
import Axios from "axios"
import Config from "@/config/app.js"
import { getOssKey } from "@/api/components.js"
import Cliper from "./Clipper.js"

export default {
  name: "CropUpload",
  mixins: [Cliper],
  props: {
    dir: {
      type: String,
      default: "jkhh50test",
    },
    itemArr: {
      type: Object,
      default: function() {
        return {}
      },
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    transCls: String, // 传递类
  },
  data: function() {
    return {
      ToastLoading: null,
      ossConfig: {
        name: "",
        key: "",
        policy: "",
        OSSAccessKeyId: "",
        signature: "",
        host: "",
        expire: "",
        success_action_status: 200, //让服务端返回200，不设置则默认返回204
      },
      ossFullName: "",
    }
  },
  methods: {
    beforeLoad() {
      this.ToastLoading = Toast.loading({
        mask: true,
        duration: 0,
        message: "加载中...",
      })
      return true
    },
    onsuccess(fileObj) {
        // 限制图片格式
      let imgType = fileObj.file.type
      if (imgType == "image/jpg" || imgType == "image/png" || imgType == "image/jpeg") {
        this.ToastLoading.clear()
        this.clipImage(fileObj)
      } else {
        return Toast("不支持该图片格式")
      }
    },
    uploadOss(dataUrl) {
      let mediaType = 1
      getOssKey({ path: this.dir, mediaType: mediaType })
        .then((r) => {
          let fileName = r.fileName + "." + this.photoType.split("/")[1]
          this.ossConfig.name = fileName
          this.ossConfig.key = r.dir + "/" + fileName
          this.ossConfig.policy = r.policy
          this.ossConfig.OSSAccessKeyId = r.accessId
          this.ossConfig.signature = r.signature
          this.ossConfig.host = r.host
          this.ossConfig.expire = r.expire
          this.ossFullName = r.host + "/" + r.dir + "/" + fileName
          let blob = this.dataURL2blob(dataUrl)
          console.log("blob", blob)
          this.uploadFile(blob)
        })
        .catch((e) => {
          console.log("e", e)
          this.ToastLoading.clear()
          Toast("设置OSS配置出错！")
        })
    },
    uploadFile(Data) {
      this.ToastLoading = Toast.loading({
        mask: true,
        duration: 0,
        message: "加载中...",
      })

      let formData = new FormData()

      for (let k in this.ossConfig) {
        formData.append(k, this.ossConfig[k])
      }

      formData.append("file", Data) //我靠，顺序有要求。
      Axios.post(this.ossConfig.host, formData, {
        // timeout: Config.timeout,
        timeout: 30000,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((r) => {
          this.$emit("uploadSuccess", this.ossFullName, this.currentIndex)
          this.ToastLoading.clear()
        })
        .catch((e) => {
          console.log("uploadFile error", e)
          Toast("上传失败，请重新上传")
          this.ToastLoading.clear()
        })
    },
    dataurlToFile(dataurl) {
      // base64 转 file
      let arr = dataurl.split(",")
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      let filename = this.photoType
      //转换成file对象
      console.log(12345)
      let myFile = new File([u8arr], filename, { type: mime })
      console.log("myFile", myFile)
      return myFile
    },
    dataURL2blob(dataURL) {
      let binaryString = atob(dataURL.split(",")[1])
      let arrayBuffer = new ArrayBuffer(binaryString.length)
      let intArray = new Uint8Array(arrayBuffer)
      let mime = dataURL.split(",")[0].match(/:(.*?);/)[1]
      for (let i = 0, j = binaryString.length; i < j; i++) {
        intArray[i] = binaryString.charCodeAt(i)
      }
      let data = [intArray]
      let result
      try {
        result = new Blob(data, { type: mime })
      } catch (error) {
        window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder
        if (error.name === "TypeError" && window.BlobBuilder) {
          var builder = new BlobBuilder()
          builder.append(arrayBuffer)
          result = builder.getBlob(type)
        } else {
          throw new Error("图片转换出错")
        }
      }
      return result
    },
  },
  mounted() {},
  beforeDestroy: function() {},
  components: { Uploader },
}
</script>
<style lang="scss">
#CropUpload {
  .upload-content {
    width: 127px;
    height: 90px;
    background: #e3e5e9;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &.wh-one {
      width: 143px;
      height: 104px;
    }

    p {
      color: #69707f;
      font-size: 12px;
    }

    img {
      width: 31px;
      height: 26px;
    }
  }
}

#clip_container.container {
  position: fixed;
  padding-top: 60px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);
  z-index: 999;

  .posbox {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  #clip_rotate {
    position: absolute;
    left: 0;
    bottom: 70px;
    width: 100vw;
    background: rgba(0, 0, 0, 1);
    display: flex;
    height: 50px;
    justify-content: center;
    color: #fff;

    p {
      width: 92%;
      display: flex;
      justify-content: space-between;
    }
  }

  .clip_bottom {
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    height: 70px;
    width: 100vw;
    align-items: center;
    background: rgba(0, 0, 0, 1);

    p {
      width: 92%;
      display: flex;
      justify-content: space-between;

      #clip_button {
        display: inline-block;
        width: auto;
        height: auto;
        border: none;
        background: none;
        color: #fff;
      }

      #cancel_clip {
        display: inline-block;
        width: auto;
        height: auto;
        border: none;
        background: none;
        color: #fff;
      }

      #clip_restore {
        display: inline-block;
        width: auto;
        height: auto;
        border: none;
        background: none;
        color: #fff;
      }
    }
  }

  .crop_main {
    #clip_image {
      max-width: 100%;
    }

    .cropper-container {
      font-size: 0;
      line-height: 0;
      position: relative;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      direction: ltr;
      -ms-touch-action: none;
      touch-action: none;

      img {
        /* Avoid margin top issue (Occur only when margin-top <= -height) */
        display: block;
        min-width: 0 !important;
        max-width: none !important;
        min-height: 0 !important;
        max-height: none !important;
        width: 100%;
        height: 100%;
        image-orientation: 0deg;
      }
    }
  }

  .crop_loading {
    display: none;
    position: fixed;
    z-index: 9;

    .crop_content {
      position: absolute;
      top: 50%;
      left: 50%;
      text-align: center;
      background: #000;
      opacity: 0.9;
      width: 100px;
      padding: 15px 0;
      vertical-align: middle;
      color: #fff;
      font-size: 16px;
      -webkit-border-radius: 3px;
      border-radius: 3px;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);

      .loading_bk {
        margin: 0 auto;
        height: 36px;
        width: 36px;
        background: url("./loading.gif") center center no-repeat;
      }

      .crop_text {
        padding-top: 10px;
        font-size: 14px;
      }
    }
  }

  .crop_success {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;

    .crop_success_text {
      position: absolute;
      top: 50%;
      left: 50%;
      text-align: center;
      background: #000;
      opacity: 0.9;
      width: 120px;
      height: 30px;
      color: #fff;
      line-height: 30px;
      font-size: 14px;
      -webkit-border-radius: 3px;
      border-radius: 3px;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
  }

  .cropper-wrap-box,
  .cropper-canvas,
  .cropper-drag-box,
  .cropper-crop-box,
  .cropper-modal {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .cropper-wrap-box {
    overflow: hidden;
  }

  .cropper-drag-box {
    opacity: 0;
    background-color: #fff;
  }

  .cropper-modal {
    opacity: 0.5;
    background-color: #000;
  }

  .cropper-view-box {
    display: block;
    overflow: hidden;
    width: 100%;
    height: 100%;
    outline: 1px solid #39f;
    outline-color: rgba(51, 153, 255, 0.75);
  }

  .cropper-dashed {
    position: absolute;
    display: block;
    opacity: 0.5;
    border: 0 dashed #eee;

    &.dashed-h {
      top: 33.33333%;
      left: 0;
      width: 100%;
      height: 33.33333%;
      border-top-width: 1px;
      border-bottom-width: 1px;
    }

    &.dashed-v {
      top: 0;
      left: 33.33333%;
      width: 33.33333%;
      height: 100%;
      border-right-width: 1px;
      border-left-width: 1px;
    }
  }

  .cropper-center {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 0;
    height: 0;
    opacity: 0.75;
  }

  .cropper-center {
    &:before {
      position: absolute;
      top: 0;
      left: -3px;
      width: 7px;
      height: 1px;
      display: block;
      content: " ";
      background-color: #eee;
    }

    &:after {
      position: absolute;
      top: -3px;
      left: 0;
      width: 1px;
      height: 7px;
      display: block;
      content: " ";
      background-color: #eee;
    }
  }

  .cropper-face,
  .cropper-line,
  .cropper-point {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    opacity: 0.1;
  }

  .cropper-face {
    top: 0;
    left: 0;
    background-color: #fff;
  }

  .cropper-line {
    background-color: #39f;
  }

  .cropper-line.line-e {
    top: 0;
    right: -3px;
    width: 5px;
    cursor: e-resize;
  }

  .cropper-line.line-n {
    top: -3px;
    left: 0;
    height: 5px;
    cursor: n-resize;
  }

  .cropper-line.line-w {
    top: 0;
    left: -3px;
    width: 5px;
    cursor: w-resize;
  }

  .cropper-line.line-s {
    bottom: -3px;
    left: 0;
    height: 5px;
    cursor: s-resize;
  }

  .cropper-point {
    width: 5px;
    height: 5px;
    opacity: 0.75;
    background-color: #39f;
  }

  .cropper-point.point-e {
    top: 50%;
    right: -3px;
    margin-top: -3px;
    cursor: e-resize;
  }

  .cropper-point.point-n {
    top: -3px;
    left: 50%;
    margin-left: -3px;
    cursor: n-resize;
  }

  .cropper-point.point-w {
    top: 50%;
    left: -3px;
    margin-top: -3px;
    cursor: w-resize;
  }

  .cropper-point.point-s {
    bottom: -3px;
    left: 50%;
    margin-left: -3px;
    cursor: s-resize;
  }

  .cropper-point.point-ne {
    top: -3px;
    right: -3px;
    cursor: ne-resize;
  }

  .cropper-point.point-nw {
    top: -3px;
    left: -3px;
    cursor: nw-resize;
  }

  .cropper-point.point-sw {
    bottom: -3px;
    left: -3px;
    cursor: sw-resize;
  }

  .cropper-point.point-se {
    right: -3px;
    bottom: -3px;
    width: 20px;
    height: 20px;
    cursor: se-resize;
    opacity: 1;
  }

  @media (min-width: 768px) {
    .cropper-point.point-se {
      width: 15px;
      height: 15px;
    }
  }

  @media (min-width: 992px) {
    .cropper-point.point-se {
      width: 10px;
      height: 10px;
    }
  }

  @media (min-width: 1200px) {
    .cropper-point.point-se {
      width: 5px;
      height: 5px;
      opacity: 0.75;
    }
  }

  .cropper-point.point-se:before {
    position: absolute;
    right: -50%;
    bottom: -50%;
    display: block;
    width: 200%;
    height: 200%;
    content: " ";
    opacity: 0;
    background-color: #39f;
  }

  .cropper-invisible {
    opacity: 0;
  }

  /*.cropper-bg {*/
  /*    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');*/
  /*}*/

  .cropper-hide {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
  }

  .cropper-hidden {
    display: none !important;
  }

  .cropper-move {
    cursor: move;
  }

  .cropper-crop {
    cursor: crosshair;
  }

  .cropper-disabled .cropper-drag-box,
  .cropper-disabled .cropper-face,
  .cropper-disabled .cropper-line,
  .cropper-disabled .cropper-point {
    cursor: not-allowed;
  }
}
</style>
